import { Injectable } from '@angular/core';
import { storageKey, StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService implements StorageService {
  /**
   * Retrieve an item from local storage
   */
  public get(key: string): string | null {
    key = storageKey(key);
    return localStorage.getItem(key);
  }

  /**
   * Sets an item in local storage
   */
  public set(key: string, value: string): void {
    key = storageKey(key);
    localStorage.setItem(key, value);
  }

  /**
   * Remove an item from local storage
   */
  public remove(key: string): void {
    key = storageKey(key);
    localStorage.removeItem(key);
  }

  /**
   * Clear local storage
   */
  public clear(): void {
    localStorage.clear();
  }
}
